import { render, staticRenderFns } from "./PuzzleEditQuestionModal.vue?vue&type=template&id=01dbc653&scoped=true"
import script from "./PuzzleEditQuestionModal.vue?vue&type=script&lang=js"
export * from "./PuzzleEditQuestionModal.vue?vue&type=script&lang=js"
import style0 from "./PuzzleEditQuestionModal.vue?vue&type=style&index=0&id=01dbc653&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dbc653",
  null
  
)

export default component.exports